'use strict';

/**
 * Constants available client side.
 *
 * These values are duplicated in server/lib/constants.js
 */
module.exports = {
    // Widths corresponding of the four sizes 'A', 'B', 'C', and 'D'.
    breakpoints: {
        A: 0,
        B: 675,
        C: 1240,
        D: 1680,
    },
    breakpointHeights: {
        D: 1050,
    },
    soccerLeagues: ['epl', 'mls', 'la liga', 'serie a'],
    fullSoccerLeagues: ['premier league', 'major league soccer', 'laliga', 'serie a'],
};
